"use strict";
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PhoneCheckStatus = void 0;
/**
 * 电话可用状态
 */
var PhoneCheckStatus;
(function (PhoneCheckStatus) {
    PhoneCheckStatus[PhoneCheckStatus["CAN_SIGN"] = 0] = "CAN_SIGN";
    PhoneCheckStatus[PhoneCheckStatus["CAN_LOGIN"] = 1] = "CAN_LOGIN";
})(PhoneCheckStatus = exports.PhoneCheckStatus || (exports.PhoneCheckStatus = {}));
